import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'RSI',
  version: 2,
  label: 'Relative Strength Index',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 20,
  inputs: [period('timeperiod', 14)],
  outputs: [line('rsi', 'RSI', COLOR.purple)],
  levels: [{ value: 70 }, { value: 50 }, { value: 30 }],
  talib: { functions: ['RSI'], expr: 'RSI(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
